import React from "react";
import { Heading } from "@/shared/components/ui";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { DialogDescription, DialogTitle } from "@/shared/components/ui";
import { CoverageModalTerms } from "@/shared/components/CoverageEditor";
import Strings from "../utils/Strings.constants";
interface TermsDialogProps {
    termsInModal: CoverageModalTerms[];
}

export const ReimbursementTermsModal: React.FC<TermsDialogProps> = props => {
    const { termsInModal } = props;

    return (
        <div className="text-md flex w-full flex-col gap-2 text-content-primary">
            <VisuallyHidden asChild>
                <DialogTitle>{Strings.TERMS_MEANING}</DialogTitle>
            </VisuallyHidden>
            <VisuallyHidden asChild>
                <DialogDescription>{Strings.TERMS_MEANING}</DialogDescription>
            </VisuallyHidden>
            <Heading level="h3" className="max-w-[80%] text-xl font-semibold">
                {Strings.TERMS_MEANING}
            </Heading>
            {termsInModal.includes("annualLimit") && (
                <>
                    <Heading level="h4" className="text-lg font-semibold">
                        {Strings.ANNUAL_LIMIT}
                    </Heading>
                    <p className="text-content-secondary">{Strings.ANNUAL_LIMIT_MEANING}</p>
                </>
            )}
            {termsInModal.includes("reimbursement") && (
                <>
                    <Heading level="h4" className="text-lg font-semibold">
                        {Strings.REIMBURSEMENT_RATE}
                    </Heading>
                    <p className="text-content-secondary">{Strings.REIMBURSEMENT_MEANING}</p>
                </>
            )}
            {termsInModal.includes("annualDeductible") && (
                <>
                    <Heading level="h4" className="text-lg font-semibold">
                        {Strings.ANNUAL_DEDUCTIBLE}
                    </Heading>
                    <p className="text-content-secondary">{Strings.ANNUAL_DEDUCTIBLE_MEANING}</p>
                </>
            )}
        </div>
    );
};
